import Reveal from "@/components/Reveal";
import { aboutParagraphs, profile } from "@/data/portfolio";

const About = () => (
    <section id="about" data-testid="about-section" className="relative py-12 sm:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid items-center gap-12 lg:grid-cols-[1.2fr_1fr] lg:gap-20">
                <Reveal className="text-center">
                    <h2 className="font-display text-3xl font-bold leading-[1.15] tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
                        Passionate about crafting{" "}
                        <em className="font-serifit text-[1.06em] font-medium italic text-[#f6e3d3]">
                            beautiful &amp; impactful
                        </em>{" "}
                        visual stories.
                    </h2>
                    <p className="mx-auto mt-8 max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg">
                        {aboutParagraphs[0]}
                    </p>
                </Reveal>

                <Reveal delay={0.15}>
                    <div data-testid="about-photo" className="group relative mx-auto max-w-[280px] sm:max-w-sm">
                        <div
                            className="animate-glow-drift absolute -inset-8 rounded-full bg-flame/15 blur-3xl"
                            aria-hidden="true"
                        />
                        <div className="relative overflow-hidden rounded-3xl border border-white/10 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)]">
                            <img
                                src={profile.photo}
                                alt={profile.name}
                                loading="lazy"
                                className="aspect-square w-full object-cover object-[50%_30%] transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                            />
                            <div
                                className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent"
                                aria-hidden="true"
                            />
                        </div>
                        <p className="mt-5 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            {profile.name} — {profile.role}
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default About;
